export enum EApiStatus {
  LOADING = 0,
  SUCCESS = 1,
  ERROR = 2,
}
